export const config = {
  title: 'Expertise proved by top industry ratings',
  ids: ['goodfirms-devops', 'todevelopers-cloud', 'businessfirms', 'itrate'],
}
